import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IotGateWaysRoutingModule } from './iot-gateways-routing.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import {
  GridModule,
  PDFModule,
  ExcelModule,
} from '@progress/kendo-angular-grid';
import { TextBoxModule } from '@progress/kendo-angular-inputs';
import { AccordionModule } from 'ngx-bootstrap/accordion';

import { IotGatewaysComponent } from './iot-gateways/iot-gateways.component';
import { SharedModule } from '../../shared/shared.module';
import { ComponentsModule } from '../../shared/components/components.module';
import { UiSwitchModule } from 'ngx-ui-switch';
import { RpCreateGatewayComponent } from './rp-create-gateway/rp-create-gateway.component';
@NgModule({
  declarations: [IotGatewaysComponent, RpCreateGatewayComponent],
  imports: [
    CommonModule,
    NgSelectModule,
    IotGateWaysRoutingModule,
    BsDatepickerModule,
    GridModule,
    PDFModule,
    ExcelModule,
    TextBoxModule,
    AccordionModule,
    SharedModule,
    ComponentsModule,
    UiSwitchModule,
  ],
  // providers: [
  //   {
  //   provide: DROPZONE_CONFIG,
  //   useValue: DEFAULT_DROPZONE_CONFIG
  // }]
})
export class IotGatewaysModule {}
